import { FC } from 'react';
import classNames from 'classnames';
import { Rnd } from 'react-rnd';

// constants
import {
  AVAILABILITY_STATUSES,
  AvailabilityStatus,
} from '../../../constants/fieldData';
import { TIMESLOT_STEP } from '../../../constants/timeslot';

import useIsMobile from '../../../hooks/useIsMobile';

interface Props {
  availabilityStatus?: AvailabilityStatus;
  length?: number;
  edge?: number;
  scale?: number;
  handleResize?: () => void;
  resizable?: boolean;
  horizontal?: boolean;
}

const Slot: FC<Props> = ({
  availabilityStatus = AVAILABILITY_STATUSES.AVAILABLE,
  length,
  edge = 0,
  scale = 1,
  handleResize = () => {},
  resizable = false,
  horizontal = false,
  ...props
}) => {
  const isMobileView = useIsMobile();

  const { flag, label } = availabilityStatus;
  const hasIcon =
    ![
      AVAILABILITY_STATUSES.AVAILABLE,
      AVAILABILITY_STATUSES.PROVISIONAL,
    ].includes(availabilityStatus) &&
    availabilityStatus.iconClasses &&
    availabilityStatus.iconClasses.length > 0;

  const classes = classNames(
    'timeslot-widget__slot',
    availabilityStatus.slotClasses,
    { 'timeslot-widget__slot--resizable': resizable }
  );

  const iconClasses = classNames(
    'fas',
    'timeslot-widget__slot-icon',
    availabilityStatus.iconClasses
  );

  const resizeHandleClasses = {
    left: 'resize-handle-left',
    right: 'resize-handle-right',
    top: 'resize-handle-up',
    bottom: 'resize-handle-down',
  };

  const resizing = horizontal
    ? { left: true, right: true }
    : { top: true, bottom: true };

  return (
    <Rnd
      {...props}
      className={classes}
      size={{
        [horizontal ? 'width' : 'height']: length,
      }}
      position={{
        x: horizontal ? edge * scale : 45,
        y: horizontal ? 15 : edge * scale,
      }}
      minWidth={TIMESLOT_STEP * 2 * (horizontal ? scale : 1)}
      minHeight={TIMESLOT_STEP * 2 * (horizontal ? 1 : scale)}
      disableDragging
      resizeHandleClasses={resizeHandleClasses}
      enableResizing={
        isMobileView ||
        !resizable ||
        flag === AVAILABILITY_STATUSES.UNAVAILABLE.flag
          ? {}
          : resizing
      }
      resizeGrid={[TIMESLOT_STEP * scale, TIMESLOT_STEP * scale]}
      onResizeStop={handleResize}
    >
      <div className="timeslot-widget__slot-inner" data-testid="slotInner">
        <span className="timeslot-widget__slot-label">
          {label}
          {hasIcon && <i className={iconClasses} data-testid="icon" />}
        </span>
      </div>
    </Rnd>
  );
};

export default Slot;
